const Header = () => {
    return (

<div className="bg-gradient-to-r from-green-900 to-green-700 py-16">
        <div className="container mx-auto px-6 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            Customer Service 24/7
          </h1>
          <p className="text-xl text-blue-100 max-w-2xl mx-auto">
            Pilih channel komunikasi yang paling nyaman untuk Anda. Tim support kami siap membantu kapan saja.
          </p>
        </div>
      </div>
    );
};
export default Header;